import { all, call, put, getContext, takeLatest } from 'redux-saga/effects';
import { ProductContentVideoActionsTypes } from '../../../enums/ActionEnums';
import ProductsAPI from '../../../api/ProductsAPI';
import { productActions } from '../../product/actions/ProductActions';
import { ProductVideoModeTypes } from '@as-react/common-types';
export function* loadProductContentVideosSaga() {
    yield takeLatest(ProductContentVideoActionsTypes.GET_PRODUCT_CONTENT_VIDEOS, getProductContentVideos);
}
function* getProductContentVideos(action) {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        const videos = yield call(ProductsAPI.getProductVideos, action.payload, servicesEndpoint, defaultRequestParams);
        const inspirationalVideos = videos &&
            videos.filter((video) => { var _a; return ((_a = video.productVideoDetail) === null || _a === void 0 ? void 0 : _a.videoMode) === ProductVideoModeTypes.INSPIRATIONAL; });
        if (inspirationalVideos) {
            yield put(productActions.setProductContentVideos(inspirationalVideos));
        }
    }
    catch (_a) { }
}
export default function* productContentVideosSaga() {
    yield all([loadProductContentVideosSaga()]);
}
